export const initialState = {
  view: 1,
  isVisible: true,
  calculationsData: {
    currentCurrencyRate: 1,
    currentCurrency: {
      currency: 'Mexican Peso', currencyCode: 'MXN', country: 'Mexico', symbol: '$',
    },
    machine: {
      name: '',
      id: '',
    },
    material: {
      values: [{ isUsingSavedMaterial: false }],
    },
    design: { typeOfWork: 'cut-or-engrave' },
    electricity_Rate: true,
    expense_Details: true,
    investment_Details: true,
    save_quotations: true,
  },
  machines: [],
  chargesbyRegion: [],
  dac: [],
  maxView: 0,
  showSidebar: window.outerWidth > 500,
  user: false,
};

const rootReducer = (state = initialState, action = { type: '', payload: '' }) => {
  switch (action.type) {
    case ('SET_VIEW'):
      return { ...state, view: action.payload };
    case ('SET_CALCULATIONS_DATA'):
      return { ...state, calculationsData: action.payload };
    case ('SET_IS_VISIBLE'):
      return { ...state, isVisible: action.payload };
    case ('SET_MACHINES'):
      return { ...state, machines: action.payload };
    case ('SET_CHARGES_BY_REGION'):
      return { ...state, chargesbyRegion: action.payload };
    case ('SET_DAC'):
      return { ...state, dac: action.payload };
    case ('SET_MAX_VIEW'):
      return { ...state, maxView: action.payload };
    case ('SET_SHOW_SIDE_BAR'):
      return { ...state, showSidebar: action.payload };
    case ('SET_USER'):
      return { ...state, user: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
